import { convertNumberToDisplayedNumberText } from "../../model/Numbers";
import InputField, { InputFieldProps } from "./InputField";

interface Props extends InputFieldProps<number> {
  formatNumber?: (value: number) => string;
}

const castToNumber = (valueAsText: string) => Number(valueAsText.replace(',', '.'));

const NumberInputField = (props: Props) => {
  return (
    <InputField {...props}
      castToType={ castToNumber }
      convertValueToText={ props.formatNumber || convertNumberToDisplayedNumberText } />
  );
};

export default NumberInputField;